module.exports = ".treeview-menu.collapse {\n  display: none;\n}\n\n.treeview-menu,\n.treeview-menu.collapse.in {\n  display: block;\n}\n"